// OLD COLORS - Commented out for reference
// Should be removed in the future
/*
const RAW_COLORS = {
  white: "#FFFFFF",

  "yellow-0": "#FEE827", //primary yellow
  "yellow-1": "#FFEB85",
  "yellow-2": "#FFF5D2",
  "yellow-3": "#FFF7DB",
  "yellow-4": "#FFFADB", //secondary yellow
  "yellow-5": "#FFFEF5",
  "yellow-6": "#FFF8D2",

  "grey-0": "#25241D", //textPrimaryColor
  "grey-1": "#555249", //textSecondaryColor
  "grey-2": "#DEDCCE",
  "grey-3": "#F0EFE4",
  "grey-4": "#F6F5EF",
  "grey-5": "#FCFBF8",
  "grey-6": "#B1BACC",
  "grey-100": "#F9F9F9",
  "grey-200": "#EFEFEF",
  "grey-300": "#E0E0E0",
  "grey-400": "#CDCDCD",
  "grey-500": "#B6B6B5",
  "grey-600": "#888785",
  "grey-700": "#4F4F4E",

  "greyLight-0": "#7F7B71",
  "greyLight-1": "#B6B4AA", //disable
  "greyLight-2": "#DEDCCE",
  "greyLight-3": "#F0EFE4",
  "greyLight-4": "#F6F5EF",
  "greyLight-5": "#FCFBF8",
  "greyLight-6": "#D9D9D9",

  "blue-0": "#2B464D",
  "blue-1": "#C7E4FF",
  "blue-2": "#E0F0FF",
  "blue-3": "#F2F7FC",
  "blue-4": "#087CBF",
  "blue-5": "#8BC7FF",
  "blue-200": "#EEF5FB",

  "brown-0": "#F4722A",

  "pink-0": "#9E3D3D", // red-700 on Figma
  "red-0": "#DC4C56",

  "orange-0": "#893815",
  "orange-1": "#FFC9A3",
  "orange-2": "#FFE6C9",
  "orange-500": "#FF9F6B",
  "orange-800": "#893815",

  "green-0": " #496728",
  "green-1": "#F0FCE4",
  "green-500": "#A4D36E"
};

const colors = {
  ...RAW_COLORS,

  "bg-primary-active": RAW_COLORS["grey-0"],

  "bg-secondary-active": RAW_COLORS["yellow-1"],
  "primary-yellow": RAW_COLORS["yellow-0"],

  "text-primary": RAW_COLORS["grey-0"],
  "text-secondary": RAW_COLORS["grey-1"],
  "text-light": RAW_COLORS["greyLight-0"],
  "bg-input": RAW_COLORS["grey-4"],
  "border-light": RAW_COLORS["grey-3"],
};
*/

// NEW THEME - SHINE (Figma Design)
const RAW_COLORS = {
  white: "#FFFFFF",

  // Entrepreneur Yellow (Full Scale)
  // For buttons, surfaces, and other interactive elements
  "entrepreneur-yellow-50": "#FEFCE8",
  "entrepreneur-yellow-100": "#FFFAC2",
  "entrepreneur-yellow-200": "#FFF389",
  "entrepreneur-yellow-300": "#FFE545",
  "entrepreneur-yellow-400": "#FCD113",
  "entrepreneur-yellow-500": "#ECB806",
  "entrepreneur-yellow-600": "#CC9D30",
  "entrepreneur-yellow-700": "#A17827",
  "entrepreneur-yellow-800": "#674818",
  "entrepreneur-yellow-900": "#513516",
  "entrepreneur-yellow-950": "#432913",

  // Accounting Green 
  // For H1 to H6 and other component surfaces (Full Scale)
  "accounting-green-50": "#E0F6EA",
  "accounting-green-100": "#C9EEDA",
  "accounting-green-200": "#9ADFB9",
  "accounting-green-300": "#63D198",
  "accounting-green-400": "#42C37B",
  "accounting-green-500": "#25BA66",
  "accounting-green-600": "#20A159",
  "accounting-green-700": "#198447",
  "accounting-green-800": "#0F5F35",
  "accounting-green-900": "#074629",
  "accounting-green-950": "#003725",
  "accounting-green-800/10": "#0F5F351A",

  // Prosperity Stone (Full Scale)
  "prosperity-stone-50": "#F9F7F1",
  "prosperity-stone-100": "#F2EEE2",
  "prosperity-stone-200": "#E8E2CD",
  "prosperity-stone-300": "#DFD5B8",
  "prosperity-stone-400": "#C2B89A",
  "prosperity-stone-500": "#AAA187",
  "prosperity-stone-600": "#88826D",
  "prosperity-stone-700": "#716D5C",
  "prosperity-stone-800": "#5A594A",
  "prosperity-stone-900": "#3E3F34",
  "prosperity-stone-950": "#2D2F27",

  // Monochrome for text and borders (Full Scale)
  "monochrome-50": "#FFFFFF",
  "monochrome-100": "#F4F4F4",
  "monochrome-200": "#E8E8E8",
  "monochrome-300": "#D0D0D0",
  "monochrome-400": "#B8B8B8",
  "monochrome-500": "#979797",
  "monochrome-600": "#787878",
  "monochrome-700": "#646464",
  "monochrome-800": "#515151",
  "monochrome-900": "#363636",
  "monochrome-950": "#262626",

  // Equity Flame
  "equity-flame-50": "#FFF3F1",
  "equity-flame-500": "#FF5032",

  // Ledger Blue
  "ledger-blue-50": "#F0F4FE",
  "ledger-blue-500": "#3A65EB",
  "ledger-blue-600": "#2F50E1", // Hover state for primary button


  //Footer bottom text
  "footer-bottom-text": "#99AFA8",
  "bg_divider": "#DCDCDC"
};

const colors = {
  ...RAW_COLORS,

  // Primary Brand Colors
  "primary-yellow": RAW_COLORS["entrepreneur-yellow-200"],
  "primary-green": RAW_COLORS["accounting-green-950"],

  // Secondary Brand Colors
  "secondary-yellow-50": RAW_COLORS["entrepreneur-yellow-50"],
  "secondary-stone-50": RAW_COLORS["prosperity-stone-50"],
  "secondary-stone-100": RAW_COLORS["prosperity-stone-100"],
  "secondary-stone-200": RAW_COLORS["prosperity-stone-200"],
  "secondary-stone-700": RAW_COLORS["prosperity-stone-700"],
  "secondary-stone-900": RAW_COLORS["prosperity-stone-900"],
  "secondary-green-700": RAW_COLORS["accounting-green-700"],
  "secondary-green-50": RAW_COLORS["accounting-green-50"],

  // Tertiary Brand Colors
  "tertiary-flame-500": RAW_COLORS["equity-flame-500"],
  "tertiary-flame-50": RAW_COLORS["equity-flame-50"],
  "tertiary-blue-500": RAW_COLORS["ledger-blue-500"],
  "tertiary-blue-50": RAW_COLORS["ledger-blue-50"],

  // Primary Monochrome Brand Colors
  "monochrome-primary": RAW_COLORS["monochrome-950"],
  "monochrome-white": RAW_COLORS["monochrome-50"],

  // Action Brand Colors
  "action-yellow": RAW_COLORS["entrepreneur-yellow-300"],


  // Headings (Specific to new design)
  "text-heading": RAW_COLORS["accounting-green-950"], // H1-H5 Color
  "text-subheader": RAW_COLORS["monochrome-800"],     // Subheader Color

  // Functional Colors
  "blue-4": RAW_COLORS["ledger-blue-500"],
  "red-0": RAW_COLORS["equity-flame-500"],

  // --- Button Semantics (Inferred from "Sign up" and "Navigation" designs) ---

  // Primary Button (Blue "Sign up")
  "btn-signup-bg": RAW_COLORS["ledger-blue-500"],
  "btn-signup-text": RAW_COLORS["white"],
  "btn-signup-hover": RAW_COLORS["ledger-blue-600"],

  //Other Primary Button
  "btn-green-bg": RAW_COLORS["accounting-green-800"],
  "btn-green-text": RAW_COLORS["white"],
  "btn-green-hover": RAW_COLORS["accounting-green-950"],

  "btn-yellow-bg": RAW_COLORS["entrepreneur-yellow-100"],
  "btn-yellow-text": RAW_COLORS["monochrome-950"],
  "btn-yellow-hover": RAW_COLORS["entrepreneur-yellow-200"],

  // Secondary Button 
  "btn-secondary-hover": RAW_COLORS["accounting-green-800/10"],
  "btn-secondary-text": RAW_COLORS["accounting-green-800"],
  "btn-secondary-border": RAW_COLORS["accounting-green-800"],


  // Navigation Button (Green Arrow)
  "btn-nav-bg": RAW_COLORS["accounting-green-50"],
  "btn-nav-icon": RAW_COLORS["accounting-green-950"],
  "btn-nav-hover": RAW_COLORS["accounting-green-950"],
  "btn-nav-hover-icon": RAW_COLORS["white"],

  "btn-nav-dark-bg": RAW_COLORS["prosperity-stone-100"],
  "btn-nav-dark-bg-hover": RAW_COLORS["prosperity-stone-50"],
  "btn-nav-dark-text": RAW_COLORS["monochrome-950"],

  // Tags / Pills
  "btn-tag-bg": RAW_COLORS["white"],
  "btn-tag-border": RAW_COLORS["accounting-green-950"],
  "btn-tag-text": RAW_COLORS["accounting-green-950"],
  "btn-tag-active-bg": RAW_COLORS["accounting-green-950"],
  "btn-tag-active-text": RAW_COLORS["white"],

  //Badge Colors
  "badge-default": RAW_COLORS["entrepreneur-yellow-200"],


  // OLD COLORS
  // Legacy Mappings - still used in some components - could be removed in future

  "yellow-0": RAW_COLORS["entrepreneur-yellow-200"], // MAPPED: Old yellow-0
  "yellow-1": RAW_COLORS["entrepreneur-yellow-50"],  // MAPPED: Old yellow-1 (lighter)

  "blue-0": RAW_COLORS["accounting-green-950"], // MAPPED: Old blue-0

  // Greys / Text
  "text-primary": RAW_COLORS["monochrome-950"],       // MAPPED: Main text is now Monochrome 950
  "grey-0": RAW_COLORS["monochrome-950"],             // MAPPED: Old grey-0

  "text-secondary": RAW_COLORS["prosperity-stone-700"], // MAPPED: Secondary text
  "grey-1": RAW_COLORS["prosperity-stone-700"],         // MAPPED: Old grey-1

  "text-light": RAW_COLORS["prosperity-stone-900"],   // MAPPED: Light text (or maybe stone-700?)
  "greyLight-0": RAW_COLORS["prosperity-stone-900"],  // MAPPED: Old greyLight-0
  "greyLight-3": RAW_COLORS["prosperity-stone-50"],  // MAPPED: Old greyLight-3
  "grey-300": RAW_COLORS["monochrome-300"], // MAPPED: Old grey-300


  // Backgrounds
  "bg-primary-active": RAW_COLORS["accounting-green-950"], // MAPPED: Active background -> Brand Green
  "bg-secondary-active": RAW_COLORS["entrepreneur-yellow-50"],
  "bg-input": RAW_COLORS["prosperity-stone-50"],      // MAPPED: Input bg -> lighter stone
  "grey-4": RAW_COLORS["prosperity-stone-50"],        // MAPPED: Old grey-4

  "greyLight-4": RAW_COLORS["prosperity-stone-50"],  // MAPPED: Old greyLight-4

  // Borders
  "border-light": RAW_COLORS["prosperity-stone-100"], // MAPPED: Light border
  "border-primary": RAW_COLORS["prosperity-stone-200"],
  "grey-3": RAW_COLORS["prosperity-stone-100"],       // MAPPED: Old grey-3
};

export default colors;